module.exports = __webpack_public_path__ + "img/ING_HOME_PAY.fea1eab4.svg";